import React, { FunctionComponent, useState, useEffect } from 'react';
import { Box, makeStyles, Theme } from '@material-ui/core';

import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { TabList } from '../../store/modules/application/types';

type DetailPageComponentProps = {
    tabList?: TabList;
    displayTabs: Function;
    onTabSelect: Function;
    handleStatusChange?: (event: React.ChangeEvent<{ value: unknown }>) => void;
};

function a11yProps(index: any) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const DetailPageComponent: FunctionComponent<DetailPageComponentProps> = (props) => {
    const { tabList, displayTabs, onTabSelect } = props;

    useEffect(() => {
        setActiveTab(0);
    }, [tabList]);

    const handleChange = (event: React.ChangeEvent<{}>, selectedActiveTab: number) => {
        setActiveTab(selectedActiveTab);
    };

    const [activeTab, setActiveTab] = useState(0);
    const tabsClasses = makeStyles((theme: Theme) => ({
        flexContainer: {
            flexWrap: 'wrap',
        },
        indicator: {
            backgroundColor: theme.palette.primary.main,
        },
    }))();

    const tabClasses = makeStyles((theme: Theme) => ({
        root: {
            fontSize: 16,
            textTransform: 'none',
            fontWeight: 'bold',
            color: '#48484',
        },
        selected: {
            color: theme.palette.primary.light,
        },
    }))();

    const renderTabsPanel = displayTabs;

    return (
        <Box height="100%" width="100%" className="verticalFillContainer">
            <Box width="100%" className="tab-nav-container">
                <Tabs
                    key={0}
                    classes={tabsClasses}
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="full width tabs example"
                >
                    {tabList?.map((value: any, index: number) => {
                        return (
                            <Tab
                                key={value.id}
                                classes={tabClasses}
                                className="case-detail-tab"
                                label={value.name}
                                {...a11yProps(index)}
                                onClick={() => {
                                    onTabSelect(value.name);
                                }}
                            />
                        );
                    })}
                </Tabs>
            </Box>
            <div className="d-flex tab-container verticalFillContent">{renderTabsPanel(activeTab)}</div>
        </Box>
    );
};

export default DetailPageComponent;
